import { captureException } from '@atlassian/error-handling/sentry';

const STORAGE_KEY = 'twc-xflow-modal-requested-trial';

type RequestedTrialData = {
	cloudId: string;
	link: string;
};

type RequestedTrialsStorage = {
	[cloudId: string]: RequestedTrialData;
};

type RequestedTrialResult = [false, null] | [true, RequestedTrialData];

export const saveRequestedTrialToLocalStorage = (cloudId: string, link: string): void => {
	try {
		// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
		const storedData = localStorage.getItem(STORAGE_KEY);
		const existingTrials: RequestedTrialsStorage = storedData ? JSON.parse(storedData) : {};

		existingTrials[cloudId] = { cloudId, link };

		// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
		localStorage.setItem(STORAGE_KEY, JSON.stringify(existingTrials));
	} catch (error) {
		captureException('Failed to save requested trial to local storage', error as Error, {
			cloudId,
			packageName: '@atlassian/twc-xflow-modal',
			teamName: 'starburst',
		});
	}
};

export const hasRequestedTrial = (cloudId: string): RequestedTrialResult => {
	try {
		// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
		const storedData = localStorage.getItem(STORAGE_KEY);
		if (!storedData) {
			return [false, null];
		}
		const allTrials: RequestedTrialsStorage = JSON.parse(storedData);
		const trialData = allTrials[cloudId];

		if (trialData) {
			return [true, trialData];
		}
		return [false, null];
	} catch (error) {
		captureException('Failed to check requested trial in local storage', error as Error, {
			cloudId,
			packageName: '@atlassian/twc-xflow-modal',
			teamName: 'starburst',
		});
		return [false, null];
	}
};

export const clearRequestedTrialFromLocalStorage = (): void => {
	try {
		// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
		localStorage.removeItem(STORAGE_KEY);
	} catch (error) {
		// Silently fail if localStorage is not available
		captureException('Failed to clear requested trial from local storage', error as Error, {
			packageName: '@atlassian/twc-xflow-modal',
			teamName: 'starburst',
		});
	}
};
